import axios from "axios";
import {GET_APPLY_TYPE } from "../types";
import {
    APPLY_JOBS_API,
    GET_APPLY_JOBS_API 
} from "../../../utils/routes";
import setSuccessMessage from "../common/setSuccessMessage";
import setErrorMessage from "../common/setErrorMessage";
import getDispatch from "../common/getDispatch";

export const addApplyJobs = (data, back) =>(dispatch) => {
  axios
    .post(  APPLY_JOBS_API , data, { withCredentials: true })
    .then((res) => {
      dispatch(setSuccessMessage(res, back));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};

export const getApplyJobs = (data) => (dispatch) => {
  console.log(data)
  axios
    .get( `${GET_APPLY_JOBS_API}/${data}`,{ withCredentials: true })
    .then((res) => {
      dispatch(getDispatch(GET_APPLY_TYPE, res));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};




export const updateApplyJobs = (data, back) => (dispatch) => {
  axios
    .put( APPLY_JOBS_API  , data, { withCredentials: true })
    .then((res) => {
      dispatch(setSuccessMessage(res, back));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};

export const deleteApllyJobs = (data) => (dispatch) => {
  axios
    .delete( APPLY_JOBS_API , { data, withCredentials: true })
    .then((res) => {
      dispatch(setSuccessMessage(res, null, getApplyJobs));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};
